import React from "react";
import superEth from "../assets/supereth.png";
export default function Card(props) {
  return (
    <div className="card">
      {props.children}
    </div>
  );
}
